import React, { useState, useEffect, useContext } from "react";
import { UserContext } from "../context/UserContext";
import { FaTimes } from "react-icons/fa";

const DonationBox = ({ onClose, selectedPurpose, isCharity = false, projectData, isPolitician = false }) => {
  const [donationAmount, setDonationAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const { emailId, phoneNo, firstName, lastName } = useContext(UserContext);
  const [showThankYou, setShowThankYou] = useState(false);
  const [isRecurring, setIsRecurring] = useState(false);
  const [frequency, setFrequency] = useState('monthly');
  const [numberOfPayments, setNumberOfPayments] = useState(12);
  const [processingStep, setProcessingStep] = useState('');
  const [processingProgress, setProcessingProgress] = useState(0);
  const [alert, setAlert] = useState({ show: false, message: '', type: '' });

  const showAlert = (message, type) => {
    setAlert({ show: true, message, type });
    setTimeout(() => setAlert({ show: false, message: '', type: '' }), 2000);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("donation") === "stripe_success") {
      setShowThankYou(true);
    } else if (params.get("donation") === "stripe_cancelled") {
      showAlert("Donation cancelled. You can try again when ready.", "error");
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const projectId = projectData?.project_id || localStorage.getItem("selectedProjectId");
    const politicianId = isPolitician ? localStorage.getItem("selectedPoliticianId") : null;

    if (!projectId && !politicianId) {
      showAlert("Error: Project or Politician ID not found.", "error");
      return;
    }

    setLoading(true);
    setProcessingStep('Redirecting to Stripe checkout...');
    setProcessingProgress(50);

    try {
      const response = await fetch("/api/process-donation", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          donationAmount,
          emailId,
          projectId,
          politicianId,
          phoneNo,
          firstName,
          lastName,
          Donation_type: isPolitician
            ? "politician donation"
            : isCharity
              ? "monthly payment"
              : selectedPurpose,
          isRecurring,
          frequency: frequency.toUpperCase(),
          numberOfPayments,
          donationType: isPolitician ? 'politician' : isCharity ? 'charity' : 'project'
        }),
      });

      const result = await response.json();
      if (result.success && result.checkoutUrl) {
        setProcessingProgress(100);
        window.location.href = result.checkoutUrl;
      } else {
        showAlert(result.message || "Payment failed. Please contact our admin at info@urcommunity.com.au for assistance.", "error");
        setLoading(false);
      }
    } catch (error) {
      console.error("Network error:", error.message);
      showAlert("Network error: Unable to process donation.", "error");
      setLoading(false);
    }
  };
  

  const renderRecurringOptions = () => (
    <div style={{ marginBottom: "20px" }}>
      <label style={{
        display: "flex",
        alignItems: "center",
        fontSize: "14px",
        color: "#555",
        marginBottom: "10px"
      }}>
        <input
          type="checkbox"
          checked={isRecurring}
          onChange={(e) => setIsRecurring(e.target.checked)}
          style={{ marginRight: "10px" }}
        />
        Make this a recurring donation
      </label>
      
      {isRecurring && (
        <>
          <select
            value={frequency}
            onChange={(e) => setFrequency(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              fontSize: "14px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              marginTop: "10px"
            }}
          >
            <option value="weekly">Weekly</option>
            <option value="fortnightly">Fortnightly</option>
            <option value="monthly">Monthly</option>
            <option value="quarterly">Quarterly</option>
            <option value="yearly">Yearly</option>
          </select>
          
          <input
            type="number"
            min="2"
            max="52"
            value={numberOfPayments}
            onChange={(e) => setNumberOfPayments(e.target.value)}
            placeholder="Number of payments"
            style={{
              width: "100%",
              padding: "8px",
              fontSize: "14px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              marginTop: "10px"
            }}
          />
        </>
      )}
    </div>
  );

  if (!emailId) {
    return (
      <div>
        <h1>Donation Box</h1>
        <p>Please log in to donate.</p>
      </div>
    );
  }

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1100,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "10px",
              width: "400px",
              textAlign: "center",
            }}
          >
            <h3 style={{ marginBottom: "20px", color: "#333" }}>Processing Donation</h3>
            <div
              style={{
                width: "100%",
                height: "20px",
                backgroundColor: "#f0f0f0",
                borderRadius: "10px",
                overflow: "hidden",
                marginBottom: "15px",
              }}
            >
              <div
                style={{
                  width: `${processingProgress}%`,
                  height: "100%",
                  backgroundColor: "#007bff",
                  transition: "width 0.3s ease-in-out",
                }}
              />
            </div>
            <p style={{ color: "#666" }}>{processingStep}</p>
          </div>
        </div>
      )}

      {showThankYou && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              width: "400px",
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              textAlign: "center",
            }}
          >
            <h1>Thank You!</h1>
            <p>Your donation has been successfully processed.</p>
            <button
              onClick={() => setShowThankYou(false)}
              style={{
                padding: "10px 20px",
                fontSize: "16px",
                fontWeight: "bold",
                color: "#fff",
                backgroundColor: "#007bff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <div
        style={{
          position: "fixed",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          backgroundColor: "transparent",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            width: "400px",
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            position: "relative",
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <FaTimes
            onClick={onClose}
            style={{
              position: "absolute",
              right: "20px",
              top: "20px",
              cursor: "pointer",
              fontSize: "20px",
              color: "#555",
            }}
          />
          <h1
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: "20px",
              color: "#000",
            }}
          >
            Donation Box
          </h1>
          {alert.show && (
            <div
              style={{
                padding: "10px",
                marginBottom: "15px",
                borderRadius: "5px",
                color: alert.type === "success" ? "#155724" : "#721c24",
                backgroundColor: alert.type === "success" ? "#d4edda" : "#f8d7da",
                border: `1px solid ${alert.type === "success" ? "#c3e6cb" : "#f5c6cb"}`,
                fontSize: "14px",
              }}
            >
              {alert.message}
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <p
              style={{
                fontSize: "14px",
                textAlign: "center",
                marginBottom: "20px",
                color: "#555",
                lineHeight: "1.6",
              }}
            >
              All donations are processed through Stripe's secure checkout, and
              amounts are in <strong>Australian Dollars (AUD$)</strong>.
              <br /> Please press the <strong>Donate</strong> button to make an
              online donation.
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <label
                htmlFor="donationAmount"
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#555",
                }}
              >
                Donation Amount (AUD$):
              </label>
              <input
                id="donationAmount"
                type="number"
                min="1"
                step="any"
                placeholder="Enter donation amount"
                value={donationAmount}
                onChange={(e) => setDonationAmount(e.target.value)}
                required
                style={{
                  width: "150px",
                  padding: "8px",
                  fontSize: "14px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  color: "#333",
                }}
              />
            </div>
            {renderRecurringOptions()}
            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                padding: "10px",
                fontSize: "16px",
                fontWeight: "bold",
                color: "#fff",
                backgroundColor: "#007bff",
                border: "none",
                borderRadius: "5px",
                cursor: loading ? "not-allowed" : "pointer",
                transition: "background-color 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
            >
              {loading ? (
                <div
                  style={{
                    display: "inline-block",
                    width: "20px",
                    height: "20px",
                    border: "2px solid #ccc",
                    borderRadius: "50%",
                    borderTopColor: "#007bff",
                    animation: "spin 1s linear infinite",
                  }}
                ></div>
              ) : (
                `${isRecurring ? 'Start' : 'Make'} Donation`
              )}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default DonationBox;
